import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";

export function ManualWelcomeModal() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const storageKey = user?.email
    ? "warroom_manual_modal_seen_" + user.email
    : null;

  useEffect(() => {
    if (!storageKey) return;
    // Don't show if already seen or if user landed directly on the manual page
    const seen = localStorage.getItem(storageKey);
    if (!seen && location.pathname !== "/manual") {
      setOpen(true);
    }
  }, [storageKey, location.pathname]);

  const markSeen = () => {
    if (storageKey) {
      try {
        localStorage.setItem(storageKey, "true");
      } catch {
        /* ignore localStorage quota/disabled errors */
      }
    }
    setOpen(false);
  };

  const handleOpenManual = () => {
    markSeen();
    navigate("/manual");
  };

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        markSeen();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  if (!open) return null;

  return (
    <>
      <div className="modal-scrim" onClick={markSeen} />
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="manual-welcome-title"
      >
        <div className="modal-head">
          <span className="label">WELCOME TO WAR ROOM</span>
          <button
            className="btn btn-sm"
            type="button"
            onClick={markSeen}
            aria-label="Close welcome prompt"
          >
            Close
          </button>
        </div>

        <div className="modal-body">
          <h3
            id="manual-welcome-title"
            style={{
              fontSize: "17px",
              fontWeight: "600",
              color: "var(--ink)",
              margin: 0,
            }}
          >
            Check Out the Insomniacs User Manual
          </h3>

          <p
            style={{
              margin: 0,
              fontSize: "13px",
              color: "var(--ink-soft)",
              lineHeight: "1.55",
            }}
          >
            Welcome to the board! To help you navigate the 10 playgrounds,
            review cadences, automated health clocks, and daily sign-off loops,
            we have added an interactive <b>User Manual</b> directly to the
            platform.
          </p>

          <div
            className="manual-callout callout-info"
            style={{ margin: "4px 0 0" }}
          >
            <b>What's inside:</b>
            <ul style={{ margin: "6px 0 0 16px", padding: 0 }}>
              <li>
                <b>Health as a Clock:</b> Understand how review cadences dictate
                healthy, at-risk, and critical states.
              </li>
              <li>
                <b>Playground Details:</b> Inspect weekly tasks, KPIs, process
                flows, and reference tables.
              </li>
              <li>
                <b>Daily Routine:</b> Learn the 09:30 IST accountability loop and
                acknowledgement bar.
              </li>
            </ul>
          </div>
        </div>

        <div className="modal-foot">
          <span className="fromnote">
            Always accessible via <b>User Manual</b> in the top bar.
          </span>
          <button className="btn btn-sm" type="button" onClick={markSeen}>
            Dismiss
          </button>
          <button
            className="btn btn-sm btn-solid"
            type="button"
            onClick={handleOpenManual}
          >
            Open User Manual
          </button>
        </div>
      </div>
    </>
  );
}
